// Theme palette definitions — overrides --brand + --brand-foreground HSL triplets
// for both light and dark modes. Persisted via localStorage and applied by
// ThemeContext at boot + on change.

export const PALETTES = {
  default: {
    label: 'Default',
    description: 'Linear-inspired muted indigo. Calm, professional, ideal for long-session ops dashboards.',
    swatch: '#5E6AD2',
    light: { brand: '232 57% 60%', brandForeground: '0 0% 100%' },
    dark:  { brand: '234 89% 67%', brandForeground: '0 0% 100%' },
  },
  ocean: {
    label: 'Ocean',
    description: 'Crisp Pacific teal. Fresh and modern — pairs well with a blue-leaning company brand.',
    swatch: '#0D9488',
    light: { brand: '174 84% 32%', brandForeground: '0 0% 100%' },
    dark:  { brand: '174 70% 48%', brandForeground: '0 0% 100%' },
  },
  forest: {
    label: 'Forest',
    description: 'Deep evergreen. Optimistic and grounded — good for sustainability or AgTech use-cases.',
    swatch: '#15803D',
    light: { brand: '142 64% 28%', brandForeground: '0 0% 100%' },
    dark:  { brand: '142 70% 45%', brandForeground: '0 0% 100%' },
  },
  sunset: {
    label: 'Sunset',
    description: 'Warm desert orange. High-energy — great for high-velocity operations and dispatch ops floors.',
    swatch: '#EA580C',
    light: { brand: '20 91% 48%', brandForeground: '0 0% 100%' },
    dark:  { brand: '24 95% 60%', brandForeground: '0 0% 100%' },
  },
};

export const DEFAULT_PALETTE = 'default';

export function applyPalette(paletteKey, themeMode) {
  const p = PALETTES[paletteKey] || PALETTES[DEFAULT_PALETTE];
  const set = themeMode === 'dark' ? p.dark : p.light;
  const root = document.documentElement;
  root.style.setProperty('--brand', set.brand);
  root.style.setProperty('--brand-foreground', set.brandForeground);
}
